export default __webpack_public_path__ + "static/image22-6b4cbae3216567f5b3127cad6a82883d.gif";